<div class="portal-request-page">

  <!-- Header -->
  <header class="pr-header">
    <div class="pr-logo-wrap">
      <mat-icon class="pr-logo-icon">lock_open</mat-icon>
    </div>
    <h2 class="pr-header-title">Bebubel Student Portal</h2>
  </header>

  <!-- Container -->
  <div class="pr-container">

    @if (step === 'idle' || step === 'sending') {
      <div class="pr-card">
        <h1 class="pr-title">Access your student portal</h1>
        <p class="pr-subtitle">
          Enter your registered email address below. We'll send you a secure, passwordless
          access link valid for <strong>24 hours</strong>.
        </p>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Your email address</mat-label>
          <mat-icon matPrefix class="pr-field-icon">mail_outline</mat-icon>
          <input
            matInput
            type="email"
            placeholder="e.g. alex@example.com"
            [(ngModel)]="email"
            (keydown.enter)="submit()"
            [disabled]="step === 'sending'"
          />
        </mat-form-field>

        <button
          mat-flat-button
          color="primary"
          class="pr-submit-btn"
          [disabled]="!isValidEmail || step === 'sending'"
          (click)="submit()"
        >
          @if (step === 'sending') {
            <mat-spinner diameter="20" class="btn-spinner"></mat-spinner>
            <span>Sending link…</span>
          } @else {
            <span class="pr-btn-inner">
              <mat-icon>send</mat-icon>
              Send access link
            </span>
          }
        </button>

        <p class="pr-security-hint">
          <mat-icon class="pr-hint-icon">security</mat-icon>
          <span>No password required. We'll verify your identity with a secure one-time link.</span>
        </p>
      </div>
    }

    @if (step === 'success') {
      <div class="pr-card pr-card--success">
        <div class="pr-success-icon-wrap">
          <mat-icon class="pr-success-icon">mark_email_read</mat-icon>
        </div>
        <h1 class="pr-title">Check your inbox!</h1>
        <p class="pr-subtitle">
          If <strong>{{ email }}</strong> is registered as a student, we have sent your secure access link.
        </p>
        <div class="pr-expiry-pill">
          <mat-icon class="pr-expiry-icon">schedule</mat-icon>
          <span>Link expires in 24 hours</span>
        </div>
        <p class="pr-subtext">
          Can't find the email? Check your spam/junk folder or request a new link below.
        </p>
        <button mat-stroked-button class="pr-again-btn" (click)="reset()">
          <mat-icon>refresh</mat-icon>
          Try another email
        </button>
      </div>
    }

    @if (step === 'error') {
      <div class="pr-card pr-card--error">
        <div class="pr-error-icon-wrap">
          <mat-icon class="pr-error-icon">error_outline</mat-icon>
        </div>
        <h1 class="pr-title">Unable to send link</h1>
        <p class="pr-subtitle">{{ errorMessage }}</p>
        <button mat-flat-button color="primary" class="m-t-16" (click)="reset()">Try again</button>
      </div>
    }

  </div>
</div>
